<div class="vs-product-container">
  <a
    class="overlay"
    *ngIf="
      (user$ | async) && (product?.sellabilityFlag || product?.quotabilityFlag)
    "
    (click)="onFavoriteClick(product)"
  >
    <em class="material-icons overlay-fav-icon">{{
      favStatus ? 'star' : 'star_border'
    }}</em>
    <span class="overlay-fav-txt"> {{ 'plp.favorite' | cxTranslate }}</span>
  </a>
  <a
    [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
    class="cx-product-image-container"
    tabindex="-1"
    (click)="gtmSelectItemEvent(product)"
  >
    <cx-media
      class="cx-product-image"
      [container]="product.images?.PRIMARY"
      [alt]="product.summary"
    ></cx-media>
  </a>

  <div class="cx-prodcurt-code">
    {{ product.code }}
  </div>

  <a
    matTooltipClass="vs-tooltip"
    [matTooltip]="product.name"
    [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
    class="cx-product-name"
    [innerHTML]="product.name"
    (click)="gtmSelectItemEvent(product)"
  ></a>

  <div
    class="cx-product-price-container"
    class="list-price mb-1"
    *ngIf="
      (product?.sellabilityFlag || product?.quotabilityFlag) &&
        !hideProductPrice &&
        product?.price &&
        !product.obsoleteProductFlag &&
        !product?.displayAlternativetext &&
        checkPriceProduct[product.code] === undefined &&
        user$ | async as user
    "
  >
    <p>{{ 'plp.listPrice' | cxTranslate }}:</p>

    <div class="cx-product-price" aria-label="Product price">
      {{ currency }} {{ product.price.formattedValue }}
    </div>
  </div>

  <div
    class="cx-product-price-container"
    class="list-price mb-1"
    *ngIf="
      (product?.sellabilityFlag || product?.quotabilityFlag) &&
        !hideProductPrice &&
        checkPriceProduct[product.code] !== undefined &&
        checkPriceProduct[product.code].price !== undefined &&
        checkPriceProduct[product.code].price.value > 0 &&
        !product?.displayAlternativetext &&
        user$ | async as user
    "
  >
    <p>{{ 'plp.listPrice' | cxTranslate }}:</p>

    <div class="cx-product-price" aria-label="Product price">
      {{ currency }}
      {{ checkPriceProduct[product.code].price.formattedValue }}
    </div>
  </div>

  <div
    class="cx-product-price-container"
    class="list-price mb-1"
    *ngIf="
      (product?.sellabilityFlag || product?.quotabilityFlag) &&
        !hideProductPrice &&
        !showError &&
        !product?.price &&
        !product.obsoleteProductFlag &&
        !product?.displayAlternativetext &&
        checkPriceProduct[product.code] === undefined &&
        user$ | async as user
    "
  >
    <p>{{ 'plp.listPrice' | cxTranslate }}:</p>

    <div class="cx-product-price" aria-label="Product price">
      {{ 'plp.unavailable' | cxTranslate }}
    </div>
  </div>

  <div
    class="cx-product-price-container"
    class="list-price mb-1"
    *ngIf="
      (product?.sellabilityFlag || product?.quotabilityFlag) &&
        !hideProductPrice &&
        !showError &&
        checkPriceProduct[product.code] !== undefined &&
        !product?.displayAlternativetext &&
        (checkPriceProduct[product.code].price?.value === 0 ||
          !checkPriceProduct[product.code].price?.value) &&
        user$ | async as user
    "
  >
    <p>{{ 'plp.listPrice' | cxTranslate }}:</p>

    <div class="cx-product-price-custom" aria-label="Product price">
      {{ 'plp.toBeQuoted' | cxTranslate }}
      <em
        class="material-icons info help pricentavail"
        matTooltipClass="vs-tooltip"
        matTooltip="{{ 'plp.priceNotAvailable' | cxTranslate }}"
        >info</em
      >
    </div>
  </div>
  <div *ngIf="showError" class="text-danger">
    {{ 'plp.priceNotAvailable' | cxTranslate }}
  </div>
  <div class="text-warning legacy-text" *ngIf="product.newLegacyMaterial">
    <i class="material-icons">warning</i>
    <span class="text">
      {{
        'plp.legacyMaterial'
          | cxTranslate : { partNo: product?.newLegacyMaterial }
      }}</span
    >
  </div>

  <div class="text-warning" *ngIf="product.obsoleteProductFlag">
    <span class="material-icons">warning </span
    >{{ 'plp.obsoletePart' | cxTranslate }}
  </div>

  <cx-add-to-cart
    [view]="view"
    [product]="product"
    [productCode]="product?.code"
    [showQuantity]="true"
    (emitCheckPriceProductObj)="fetchCheckPriceProductObj($event)"
    (priceNotFound)="priceNotFound($event)"
  ></cx-add-to-cart>
</div>
